module.exports = __webpack_public_path__ + "img/share-img.74d707fb.png";